<div class="flex flex-col aa-input-general h-155 2xl:h-200">
  <div class="flex justify-between items-center m-4 border-b border-customBlueHard">
    <p class="text-general-title color-blue">
      {{ 'quotation.fieldNames.procedures' | translate }}
    </p>

    <button
      (click)="closeModal()"
      class="!flex !justify-center !items-center"
      color="primary"
      mat-icon-button
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="flex flex-col gap-4 p-4 items-center">
    <div class="w-[90%] m-auto flex flex-col gap-4">
      <div class="w-full flex aa-input-general flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">{{
          'quotation.fieldNames.totalAmount' | translate
        }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [placeholder]="'quotation.fieldNames.totalAmount' | translate"
            disabled="true"
            autocomplete="off"
            [value]="quotationFormalityAmount.totalFormalities"
            [prefix]="'$'"
            [thousandSeparator]="','"
            [mask]="'separator'"
          />
        </mat-form-field>
      </div>
      <div class="flex gap-4">
        <div class="w-full flex aa-input-general flex-col">
          <mat-label class="text-(--comp-input-label-normal) px-4">{{
            'quotation.labels.addProcedure' | translate
          }}</mat-label>
          <mat-form-field appearance="outline" class="input-mat-form-field w-[50%]">
            <mat-select (selectionChange)="onChangeFormality($event.source.selected)">
              @for (formality of formalitys; track formality.formalitieId) {
                <mat-option [value]="formality.formalitieId">
                  {{ formality.description }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="w-full flex"></div>
        </div>
        <button
          matButton="filled"
          class="w-45 h-12! rounded-xl text-general bg-primary!"
          (click)="createFormality()"
        >
          {{ 'quotation.labels.add' | translate }}
        </button>
      </div>
    </div>

    <div class="w-[90%] flex flex-col gap-4 m-auto pb-3">
      <div class="text-general-subtitle bg-[--brand-azul-primario] w-full rounded-lg p-2 px-4">
        {{ 'quotation.titles.selectedProcedures' | translate }}
      </div>
      <div class="table">
        <table mat-table [dataSource]="quotationFormalitys" class="mat-elevation-z8">
          <ng-container matColumnDef="Descripcion">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'quotation.fieldNames.description' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="pt-4">
              @if (
                element.formalitiesDescription === 'PLACAS Y DERECHOS' ||
                element.formalitiesDescription === 'VERIFICACION' ||
                element.formalitiesDescription === 'GESTORIA'
              ) {
                <div class="pt-4">
                  {{ element.formalitiesDescription }}
                </div>
              }

              @if (
                element.formalitiesDescription != 'PLACAS Y DERECHOS' &&
                element.formalitiesDescription != 'VERIFICACION' &&
                element.formalitiesDescription != 'GESTORIA'
              ) {
                <div class="pt-4">
                  <mat-form-field appearance="outline" class="w-full px-4">
                    <input
                      matInput
                      type="text"
                      id="formalityDescription{{ element.id }}"
                      [(ngModel)]="formalityDescription[element.id]"
                      (value)="(element.formalitiesDescription)"
                      (change)="updateFormalitys(element)"
                      [disabled]="
                        element.formalitiesDescription === 'PLACAS Y DERECHOS' ||
                        element.formalitiesDescription === 'VERIFICACION' ||
                        element.formalitiesDescription === 'GESTORIA' ||
                        element.formalitiesDescription === 'TENENCIA'
                      "
                    />
                  </mat-form-field>
                </div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="Precio">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'quotation.fieldNames.price' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="pt-4">
                <mat-form-field appearance="outline" class="w-full px-4">
                  <input
                    matInput
                    [mask]="'separator'"
                    [prefix]="'$'"
                    [thousandSeparator]="','"
                    [allowNegativeNumbers]="true"
                    id="formalityCost{{ element.id }}"
                    [(ngModel)]="formalitysCost[element.id]"
                    (value)="(element.cost)"
                    (change)="updateFormalitys(element)"
                  />
                </mat-form-field>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="Delete">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td mat-cell *matCellDef="let element">
              <button matIconButton (click)="openDialogConfirm(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>

    <div class="w-full flex justify-center">
      <button
        matButton="filled"
        class="w-45 h-12! rounded-xl text-general bg-primary!"
        (click)="confirmAndCloseModal()"
      >
        {{ 'quotation.labels.update' | translate }}
      </button>
    </div>
  </div>
</div>
